document.addEventListener('click', event => {
  if (!event.target.closest('.bls-localization')) document.querySelectorAll('.bls-localization[open]').forEach(menu => { menu.open = false; });
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.bls-localization[open]').forEach(menu => { menu.open = false; });
});
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.bls-policy-shell .shopify-policy__body');
  const toc = document.querySelector('[data-policy-toc]');
  if (!container || !toc) return;
  const allHeadings = [...container.querySelectorAll('h2,h3')];
  const policyTitle = document.querySelector('.shopify-policy__title')?.textContent.trim().toLocaleLowerCase();
  if (allHeadings[0] && policyTitle && allHeadings[0].textContent.trim().toLocaleLowerCase().startsWith(policyTitle)) allHeadings[0].hidden = true;
  const headings = allHeadings.filter(heading => !heading.hidden);
  if (!headings.length) { toc.closest('aside').hidden = true; return; }
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = 'bls-policy-' + (index + 1);
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;
    toc.append(link);
  });
});
